module.exports = __webpack_public_path__ + "img/pProject-banner.c9f1dc68.jpg";